import { c as _c } from "react/compiler-runtime";
import * as RadixDialog from '@radix-ui/react-dialog';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { cx } from 'class-variance-authority';
import { AnimatePresence, easeOut, motion } from 'framer-motion';
import { memo } from 'react';
export type SidebarProps = {
  children: React.ReactNode;
  footer?: React.ReactNode;
  isOpen: boolean;
  onClickOutside?: (event: CustomEvent) => void;
  size?: 'md' | 'lg' | 'xl' | 'xxl';
  title: string;
};
const SIZE_WIDTHS = {
  md: 'w-[500px]',
  lg: 'w-[880px]',
  xl: 'w-[1080px]',
  xxl: 'w-[1280px]'
} as const;
const TRANSITION_CONFIG = {
  duration: 0.2,
  ease: easeOut
};
const Sidebar = t0 => {
  const $ = _c(14);
  const {
    title,
    children,
    footer,
    isOpen,
    onClickOutside,
    size: t1
  } = t0;
  const size = t1 === undefined ? "md" : t1;
  let t2;
  if ($[0] !== onClickOutside) {
    t2 = event => {
      onClickOutside?.(event as CustomEvent);
    };
    $[0] = onClickOutside;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleClickOutside = t2;
  let t3;
  if ($[2] !== children || $[3] !== footer || $[4] !== handleClickOutside || $[5] !== isOpen || $[6] !== size || $[7] !== title) {
    t3 = isOpen && <RadixDialog.Portal forceMount={true}><RadixDialog.Title asChild={true}><VisuallyHidden>{title}</VisuallyHidden></RadixDialog.Title><RadixDialog.Content aria-describedby={undefined} asChild={true} onEscapeKeyDown={_temp} onPointerDownOutside={handleClickOutside}><motion.div initial={{
          opacity: 0,
          x: 100
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: 100
        }} transition={TRANSITION_CONFIG} style={{
          top: "calc(51px + var(--assume-banner-height, 0px) + var(--environment-banner-height, 0px) + var(--auditor-banner-height, 0px))"
        }} className={cx("fixed right-0 bottom-0 z-drawer max-md:max-w-full", "flex flex-col bg-primary focus-visible:outline-none", "border-l border-t border-tertiary", "dialog-page", SIZE_WIDTHS[size])}><div className="flex-1 overflow-y-auto">{children}</div>{footer && <footer className="flex items-center justify-between w-full h-[56px] shrink-0 border-t border-tertiary border-solid px-3 py-4 box-border">{footer}</footer>}</motion.div></RadixDialog.Content></RadixDialog.Portal>;
    $[2] = children;
    $[3] = footer;
    $[4] = handleClickOutside;
    $[5] = isOpen;
    $[6] = size;
    $[7] = title;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <AnimatePresence>{t3}</AnimatePresence>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== isOpen || $[12] !== t4) {
    t5 = <RadixDialog.Root open={isOpen} modal={false}>{t4}</RadixDialog.Root>;
    $[11] = isOpen;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
export default memo(Sidebar);
function _temp(event_0) {
  return event_0.preventDefault();
}